const reducersName = 'auth';

export const authSelectors = {
	isAuthenticated: (state) => state[reducersName].isAuthenticated,
};
